import Vue from 'vue'
import Router from 'vue-router'
import print from './print'
import { cloneDeep } from 'lodash'
const Main = () => import ('../components/main/main.vue')
const pExpertIndex = () => import ('../components/pExpertIndex.vue')
const exProjectIndex = () => import ('../components/exProjectIndex.vue')
const exPsuIndex = () => import ( '../components/exPsuIndex.vue')
const exPqcCheckSumIndex = () => import ('../components/exPqcCheckSumIndex.vue')
const exExpertScoringTab = () => import ( '../components/exExpertScoringTab.vue')
const exSynthesScoringIndex = () => import ('../components/exSynthesScoringIndex.vue')
const exMeetingSignIndex = () => import ( '../components/exMeetingSignIndex.vue')
const exPqcCheckTab = () => import ('../components/exPqcCheckTab.vue')
const exApplyForModificationFrom = () => import ('../components/exApplyForModificationFrom.vue')

Vue.use(Router)

const routes = [
  ...print,
  {
    path: '/',
    component: Main,
    children: [
      {
        path: 'pExpertIndex',
        component: pExpertIndex,
        name: 'pExpertIndex',
        role: 'common',
        meta: {title: '评审人', keepAlive: true}
      },
      {
        path: 'exProjectIndex',
        component: exProjectIndex,
        name: 'exProjectIndex',
        role: 'common',
        meta: {title: '项目概况', keepAlive: true}
      },
      {
        path: 'exPsuIndex',
        component: exPsuIndex,
        name: 'exPsuIndex',
        role: 'common',
        meta: {title: '报价一览', keepAlive: true}
      },
      {
        path: 'exPqcCheckTab',
        component: exPqcCheckTab,
        name: 'exPqcCheckTab',
        role: 'common',
        meta: {title: '项目初审', keepAlive: true}
      },
      {
        path: 'exPqcCheckSumIndex',
        component: exPqcCheckSumIndex,
        name: 'exPqcCheckSumIndex',
        role: 'leader',
        meta: {title: '初审汇总', keepAlive: true}
      },
      {
        path: 'exExpertScoringTab',
        component: exExpertScoringTab,
        name: 'exExpertScoringTab',
        role: 'common',
        meta: {title: '项目评分', keepAlive: true}
      },
      {
        path: 'exSynthesScoringIndex',
        component: exSynthesScoringIndex,
        name: 'exSynthesScoringIndex',
        role: 'leader',
        meta: {title: '评分汇总', keepAlive: true}
      },
      {
        path: 'exMeetingSignIndex',
        component: exMeetingSignIndex,
        name: 'exMeetingSignIndex',
        role: 'common',
        meta: {title: '评审会签', keepAlive: true}
      },
      {
        path: 'exApplyForModificationFrom',
        component: exApplyForModificationFrom,
        name: 'exApplyForModificationFrom',
        role: '',
        meta: {title: '申请修改'}
      },
    ]
  }
]

const router = new Router({
  routes
})
router.afterEach(to => {
  const app = router.app
  app.$store && app.$store.commit('open_expert_new_tabs', to)
})
let tempRoutes = cloneDeep(routes)
tempRoutes.shift()
export {router, tempRoutes}